import { render, staticRenderFns } from "./SkinBanner.vue?vue&type=template&id=d096a8fc&"
import script from "./SkinBanner.vue?vue&type=script&lang=ts&"
export * from "./SkinBanner.vue?vue&type=script&lang=ts&"
import style0 from "./SkinBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports